import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";

export default function AdminBusiness() {
  const [b, setB] = useState(null);

  useEffect(() => { api.get("/business").then(r => setB(r.data)); }, []);

  const save = async () => {
    try {
      const payload = { ...b, booking_fee_aud: parseFloat(b.booking_fee_aud) || 20 };
      await api.put("/business", payload);
      toast.success("Business profile saved");
    }
    catch { toast.error("Failed"); }
  };

  if (!b) return <div className="p-10">Loading...</div>;

  const fields = [
    ["name", "Business name"],
    ["tagline", "Tagline"],
    ["phone", "Phone"],
    ["whatsapp", "WhatsApp (E.164)"],
    ["email", "Email"],
    ["office_address", "Head office address"],
    ["opening_hours", "Opening hours"],
    ["booking_fee_aud", "Booking fee (AUD) — charged at booking to secure the slot"],
  ];

  return (
    <div className="p-8 md:p-12 max-w-3xl">
      <div className="overline">Admin</div>
      <h1 className="font-serif-display text-4xl mt-2">Business Profile</h1>
      <div className="mt-10 grid md:grid-cols-2 gap-6">
        {fields.map(([k, label]) => (
          <div key={k} className={k === "tagline" || k === "office_address" ? "md:col-span-2" : ""}>
            <label className="overline">{label}</label>
            <input value={b[k] || ""} onChange={(e) => setB({ ...b, [k]: e.target.value })}
                   className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-3 outline-none"/>
          </div>
        ))}
        <div className="md:col-span-2">
          <label className="overline">Shops (comma separated)</label>
          <input value={(b.shops || []).join(", ")}
                 onChange={(e) => setB({ ...b, shops: e.target.value.split(",").map(s => s.trim()).filter(Boolean) })}
                 className="mt-2 w-full border-b-2 border-[#E2E8F0] focus:border-[#0F172A] bg-transparent py-3 outline-none"/>
        </div>
      </div>
      <button data-testid={ADMIN.businessSave} onClick={save}
              className="mt-8 px-8 py-3 bg-[#D4AF37] text-[#0F172A] text-xs uppercase tracking-[0.25em] hover:bg-[#B8941F]">
        Save
      </button>
    </div>
  );
}
